import api from './api';

export interface PublicTestimonial {
  id: string;
  name: string;
  role: string;
  company?: string;
  content: string;
  avatar?: string;
  rating: number;
  featured: boolean;
  order: number;
}

export const testimonialService = {
  async getAll(): Promise<PublicTestimonial[]> {
    try {
      const response = await api.get('/testimonials');
      const data = response.data?.data ?? response.data;
      return Array.isArray(data) ? data : [];
    } catch (error) {
      console.error('Failed to fetch testimonials:', error);
      return [];
    }
  },
};
